module.exports = __webpack_public_path__ + "static/media/engineeringStudents.88c639b8.png";